import { AgentApiPath, useHallApi } from '@99fun-agent/hooks'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useDashboardStore = defineStore('dashboardStore', () => {
  const { authGet } = useHallApi()

  const _dashboardData = ref<IDashboardReply>()
  const dashboardData = computed(() => _dashboardData)
  const reqGetDashboard = async () => {
    const r = await authGet<IDashboardReply>(
      AgentApiPath.GetDashboard,
      {},
      {
        showErrorCodeTip: true,
        showLoading: true
      }
    )
    if (r.isSuccess) {
      _dashboardData.value = r.data
    }
    return r
  }
  const reset = () => {
    _dashboardData.value = undefined
  }

  return { reset, reqGetDashboard, dashboardData }
})

export interface IDashboardReply {
  /**
   * 邀请获得比率
   */
  dividendRatio: number
  /**
   * 产品手续费比率
   */
  productFeeRatio: number
  /**
   * 注册人数
   */
  registerCount: number
  /**
   * 登陆人数
   */
  loginCount: number
  /**
   * 充值人数
   */
  depositCount: number
  /**
   * 首充人数
   */
  firstDepositCount: number
  /**
   * 充值金额
   */
  depositAmount: number
  /**
   * 提现金额
   */
  withdrawAmount: number
  /**
   * 有效下注金额
   */
  validBetAmount: number
  /**
   * 总中奖金额
   */
  winAmount: number
  /**
   * 总获得活动奖金
   */
  bonusAmount: number
  /**
   * 盈亏
   */
  netEarningAmount: number
}
